import * as React from "react";
import { Box, Typography } from "@mui/material";
import { platformCardSx, platformFonts } from "../tickitPlatformTheme";

export default function PlatformCard({ title, headerAction, children, sx = {}, contentSx = {}, flush }) {
  const bodyPad = flush ? 0 : 2.5;
  const headerPad = flush ? { px: 2.5, pt: 2.5, pb: 0 } : {};

  return (
    <Box sx={{ ...platformCardSx, p: flush ? 0 : 2.5, mb: 2.5, ...sx }}>
      {(title || headerAction) && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 1,
            ...headerPad,
          }}
        >
          {title && (
            <Typography
              sx={{
                fontFamily: platformFonts.display,
                fontWeight: 700,
                fontSize: "0.9375rem",
                color: "var(--platform-text)",
              }}
            >
              {title}
            </Typography>
          )}
          {headerAction}
        </Box>
      )}
      <Box sx={{ px: bodyPad, pb: bodyPad, ...contentSx }}>{children}</Box>
    </Box>
  );
}
